exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.errorContent[data-v-5c7a2dea] {\n\tflex: 1;\n\tmargin: 100px 0;\n}\n", ""]);

// exports
